// Since this lives outside of the app
// (And outside of Routes)
// it does not have access to useParams
export const getPageIdFromURL = () => {
    let url = document.location.href;

    url = url.replace(/\?.*/, '');
    url = url.replace(/#.*/, '');

    const parts = url.split(/\//);
    const pageIdCur = parts.pop();

    return pageIdCur;
};
